import AdultPostedGigs from "../../../components/adult/gigs/AdultPostedGigs";
import BusinessListingsWorkspace from "../../../components/business-listings/BusinessListingsWorkspace";
import { useAuth } from "../../../hooks/useAuth";
import { isBusinessAccount } from "../../../utils/AuthUtils";

const AdultGigsPage = () => {
  const { user } = useAuth();

  if (isBusinessAccount(user?.accountType)) {
    return <BusinessListingsWorkspace />;
  }

  return <AdultPostedGigs />;
};

export default AdultGigsPage;
